export default __webpack_public_path__ + "img/bg_consultation_ps-1e3aa7d5f61622eae9490d8b6ad850a0.png";